// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"ff4c9b51","38":"ab8a38fe","144":"70e1458d","151":"dbf62ff2","276":"42ae71c5","298":"cc50b27d","331":"9b9fce9c","372":"9b854114","421":"d8d56b2c","639":"ef9dc524"}[chunkId] + ".chunk.js";
};